import { Component } from '@angular/core';
import { NotificationService } from '../../services/notification.service';


@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent {
  constructor(public notificationService: NotificationService) { }
}